import { useState } from 'react'
import { DigitMode, LottoBetList } from '../../../BetLotto.types'
import { useTranslation } from 'react-i18next'
import SearchAndRotation from '../SearchAndRotation/SearchAndRotation'
import useSearchAndRotation from '../SearchAndRotation/useSearchAndRotation'
import SelectBetNumber from '../SelectBetNumber/SelectBetNumber'
import { BasePanelProps } from '../../PanelSelection.types'

type ThreePanelProps = Omit<BasePanelProps, 'betList'> & {
  betList?: LottoBetList[]
}

const NUMBER_RANGES = [
  '000',
  '100',
  '200',
  '300',
  '400',
  '500',
  '600',
  '700',
  '800',
  '900',
]

const ThreePanel: React.FC<ThreePanelProps> = ({
  activeBetType,
  betList,
  addLottoListAndHandleResponse,
  onDeleteByNumberAndType,
  getLimitTypeUI,
}) => {
  const { t } = useTranslation()
  const [selectedRange, setSelectedRange] = useState('000')
  const { searchQuery, setSearchQuery, rotated, handleRotate } =
    useSearchAndRotation()

  const handleRangeSelect = (range: string) => {
    setSelectedRange(range)
  }

  const onSelectBetNumber = (betNumber: string) => {
    const selectedList = betList?.filter((bet) =>
      bet.items.some((item) => item.number === betNumber),
    )
    if (selectedList?.length && selectedList?.length > 0) {
      onDeleteByNumberAndType?.(betNumber, activeBetType)
    } else {
      if (rotated) {
        addLottoListAndHandleResponse(betNumber, activeBetType, 1, {
          rotated: true,
        })
      } else {
        addLottoListAndHandleResponse?.(betNumber, activeBetType, 1)
      }
    }
  }
  const isDisabled = activeBetType?.length === 0 || !activeBetType
  return (
    <div>
      <div>
        <h5 className="text-[var(--caption-text)] text-base font-medium mb-4 text-left">
          {t('betDetailPanel.selectRange')}
        </h5>
      </div>
      <div className="grid grid-cols-5 md:grid-cols-5 lg:grid-cols-10 gap-3 mb-6">
        {NUMBER_RANGES.map((range) => (
          <button
            type="button"
            key={range}
            onClick={() => handleRangeSelect(range)}
            className={`flex items-center justify-center py-3 px-4 rounded-lg border font-semibold text-base transition-all  ${
              isDisabled
                ? 'bg-[var(--grid-item-disabled-bg)] text-[var(--grid-item-disabled-text)] border-[var(--grid-item-disabled-border)] cursor-not-allowed'
                : selectedRange === range
                  ? 'btn-active-state border-[var(--bet-type-active-border)] cursor-pointer'
                  : 'bg-[var(--bet-type-bg)] text-[var(--bet-type-text)] border-[var(--bet-type-border)] hover:bg-[var(--bet-type-hover-bg)] hover:text-[var(--bet-type-hover-text)] hover:border-[var(--bet-type-hover-border)] cursor-pointer'
            }`}
          >
            {range}
          </button>
        ))}
      </div>
      <SearchAndRotation
        digitMode={DigitMode.THREE_DIGIT}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        onRotateClick={handleRotate}
        isRotated={rotated}
      />
      <SelectBetNumber
        digitMode={DigitMode.THREE_DIGIT}
        selectedRange={selectedRange}
        searchQuery={searchQuery}
        betList={betList}
        onSelectBetNumber={onSelectBetNumber}
        isDisabled={isDisabled}
        getLimitTypeUI={getLimitTypeUI}
        activeBetType={activeBetType}
      />
    </div>
  )
}

export default ThreePanel
